import protoRoot from "../proto-root";

function create({ state }: { state: AlarmState }) {
  const CameraAlarmStatus = protoRoot.lookupType("comm.CameraAlarmStatus");
  const AlarmState = CameraAlarmStatus.lookupEnum("AlarmState");

  return CameraAlarmStatus.create({
    state: AlarmState.values[state]
  });
}

const cameraAlarmStatus = { create };

export default cameraAlarmStatus;
